module.exports = __webpack_public_path__ + "static/media/mariadb.0bbba1b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mariadb.png
// module id = 143
// module chunks = 0